import { Component, inject, Inject, input, output } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { RegexLib } from '../../../core/constants/regex.constants';
import { MatError, MatFormField, MatFormFieldModule, MatHint } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { MatInputModule } from '@angular/material/input';
import { SharedService } from '../../../core/services/shared.service';


@Component({
  selector: 'isc-textarea-control',
  imports: [MatFormField, MatFormFieldModule, MatInputModule, MatIcon, MatHint, MatError, ReactiveFormsModule, CommonModule],
  templateUrl: './textarea-control.html',
  styleUrl: './textarea-control.scss',
})
export class TextareaControl {

  // ======================================================
  // INPUTS (NEW WAY)
  // ======================================================

  label = input<string>('');
  ispFormControl = input.required<FormControl>();
  placeholder = input<string>('');
  icon = input<string>('');
  hint = input<string>('');
  minlength = input<number>(0);
  maxlength = input<number>(250);
  countChars = input<boolean>(false);
  error = input<boolean>(false);
  errorMessage = input<string>('');
  bold = input<boolean>(false);
  suffixIcon = input<string>('');
  rows = input<number>(2);
  specialCharacterValidation = input<boolean>(false);
  disabled = input<boolean>(false);
  specialCharacterValidationErrorClass = input<string>('-mt-5');

  // ======================================================
  // OUTPUTS (NEW WAY)
  // ======================================================

  onBlur = output<void>();
  valueChange = output<string>();
  isError = output<boolean>();

  // ======================================================
  // STATE
  // ======================================================

  onlyAllowedCharactersPresent = false;
  allowedCharacters = RegexLib.OnlyAllowedSpecialCharacters;

  readonly sharedService = inject(SharedService);

  // ======================================================
  // EVENTS
  // ======================================================

  handleBlur(): void {
    this.onBlur.emit();
  }

  handleModelChange(value: string): void {

    const control = this.ispFormControl();

    if (!control) return;

    if (this.specialCharacterValidation()) {
      this.onlyAllowedCharactersPresent =
        !this.sharedService.OnlyAllowedCharactersPresent(control.value);
    }

    if (this.onlyAllowedCharactersPresent) {
      control.setErrors({ invalid: true });
    }

    this.valueChange.emit(value);
    this.isError.emit(control.valid);
  }
}
